/*
 * Copyright (c) 2018. Viscomp LLC. All rights are reserved!
 */

const Utils = require("../Utils");
/**
 * Contact form client-side functionality
 */
const ContactForm = function (selectorEl) {
  this.selectorEl = selectorEl;
  this.EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  this._attachEvents();
  this._translateStatusMessages();
  this.formSubmitted = false;
  function onChange(e) {
    let target = e.target;
    if (target.getAttribute("data-field-name") === null) {
      return;
    }
    if (this.formSubmitted) {
      this._clearError();
      if (!this.isValid()) {
        this._logError();
      }
    }
  }
  Utils.on("change", this.selectorEl, onChange);
  Utils.on("input", this.selectorEl, onChange);
};
ContactForm.prototype._logError = function () {
  let errorMsgDiv = document.createElement("div");
  errorMsgDiv.setAttribute("data-cf-invalid-form", "");
  errorMsgDiv.innerHTML = __("Form data is not valid!");
  errorMsgDiv.classList.add("error");
  this.selectorEl.appendChild(errorMsgDiv);
};
ContactForm.prototype.printFieldError = function (fieldEl, fieldData) {
  // var elements = this.selectorEl.querySelectorAll("input[data-field-name=" + fieldData.name + "],textarea[data-field-name=" + fieldData.name + "],select[data-field-name=" + fieldData.name + "]");

  // for (let i = 0; i< elements.length; i++) {
  //     let el = elements[i];

  // let eventType = 'change';

  //Different behaviour, based on field type
  switch (fieldEl.getAttribute("data-field-type")) {
    case "radio":
      {
        let elements = this.selectorEl.querySelectorAll("input[data-field-name=" + fieldData.name + "]");
        for (let i = 0; i < elements.length; i++) {
          //Add error class to radio
          if (elements[i]) {
            elements[i].classList.add("error");

            //Add error class to parent fieldset
            elements[i].parentNode.parentNode.classList.add("error");
          }
        }
      }
      break;
    case "checkbox":
      {
        let elements = this.selectorEl.querySelectorAll("input[data-field-name=" + fieldData.name + "]");
        for (let i = 0; i < elements.length; i++) {
          //Add error class to checkbox
          if (elements[i]) {
            elements[i].classList.add("error");

            //Add error class to label
            if (this.selectorEl.querySelector('label[for="' + elements[i].getAttribute("id") + '"]')) {
              this.selectorEl.querySelector('label[for="' + elements[i].getAttribute("id") + '"]').classList.add("error");
            }
          }
        }
      }
      break;
    default:
      {
        // eventType = 'input';
        if (fieldEl) {
          fieldEl.classList.add("error");
        }
      }
  }

  // el.addEventListener(eventType, function (e) {
  //     this.validateField(fieldData.name);
  //     if (this.selectorEl.querySelectorAll('.error').length == 1 && this.selectorEl.querySelector('.error').hasAttribute('data-cf-invalid-form')) {
  //         this.selectorEl.querySelector('[data-cf-invalid-form]').style.display = 'none';
  //     } else {
  //         this.selectorEl.querySelector('[data-cf-invalid-form]').style.display = 'block';
  //     }
  // }.bind(this));
  // }

  // if there are no error message, do not print anything
  if (fieldData.errorMessages === void 0) {
    return;
  }

  // create message div
  let errorMsgDiv = document.createElement("div");

  // print common message for now
  errorMsgDiv.innerHTML = fieldData.errorMessages["common"];

  // attach the error
  errorMsgDiv.setAttribute("data-field-error", fieldData["name"]);
  fieldEl.parentNode.insertBefore(errorMsgDiv, fieldEl.nextSibling);
};
ContactForm.prototype.removeFieldError = function (fieldElName) {
  //Remove error div
  let invalidElem = this.selectorEl.querySelector('[data-field-error="' + fieldElName + '"]'),
    mainElem = this.selectorEl.querySelector('[data-field-name="' + fieldElName + '"]');
  if (invalidElem) {
    invalidElem.parentNode.removeChild(invalidElem);
  }

  //Remove error class
  let elemsError = this.selectorEl.querySelectorAll('.error[data-field-name="' + fieldElName + '"]');
  if (elemsError) {
    for (let i = 0; i < elemsError.length; i++) {
      elemsError[i].classList.remove("error");
    }
  }
  switch (mainElem.getAttribute("data-field-type")) {
    case "radio":
      {
        //Remove error class from parent fieldset
        this.selectorEl.querySelector('[data-field-name="' + fieldElName + '"]').parentNode.parentNode.classList.remove("error");
      }
      break;
    case "checkbox":
      {
        let allInputs = this.selectorEl.querySelectorAll('[data-field-name="' + fieldElName + '"]');
        for (let i = 0; i < allInputs.length; i++) {
          this.selectorEl.querySelector('label[for="' + allInputs[i].getAttribute("id") + '"]');
        }
      }
      break;
  }
};
ContactForm.prototype._clearError = function () {
  let elem = this.selectorEl.querySelector("[data-cf-invalid-form]");
  if (elem) {
    this.selectorEl.removeChild(elem);
  }
};
ContactForm.prototype._attachEvents = function () {
  let self = this;
  this.selectorEl.addEventListener("submit", function (e) {
    self._clearError();
    try {
      if (!self.isValid()) {
        e.preventDefault(); // stop form from submiting
        self._logError();
        self.formSubmitted = true;
      }
    } catch (err) {
      // prevent sumbit on error
      e.preventDefault();
      console.error(err);
    }
  }.bind(this));
};
ContactForm.prototype._translateStatusMessages = function () {
  let el = this.selectorEl.querySelector("span.translatable-message");
  if (el && el.innerHTML) {
    el.innerHTML = __(el.innerHTML.trim());
  }
};

/**
 * element: HTMLElement
 * cb: (el: HTMLElement) => void
 */
ContactForm.prototype._forEachEl = function (elements, cb) {
  for (let i = 0; i < elements.length; ++i) {
    cb && cb(elements[i], i);
  }
};

/**
 * element: HTMLElement
 */
ContactForm.prototype._getVal = function (element) {
  let elementType = element.getAttribute("data-field-type");

  // text && textarea
  if (elementType === "text" || elementType === "textarea" || elementType === "select") {
    return element.value;
  }
  if (elementType === "radio") {
    let elName = element.getAttribute("data-field-name");
    let value = null;
    let childrenEl = this.selectorEl.querySelectorAll('input[data-field-name="' + elName + '"]');
    this._forEachEl(childrenEl, function (el) {
      if (el.checked) {
        value = el.checked;
      }
    });
    return value;
  }
  if (elementType === "checkbox") {
    let elName = element.getAttribute("data-field-name");
    let childrenEl = this.selectorEl.querySelectorAll('input[data-field-name="' + elName + '"]');
    let value = null;
    this._forEachEl(childrenEl, function (el) {
      if (el.checked) {
        value = el.checked;
      }
    });
    return value;
  }
};
ContactForm.prototype.getFieldsValues = function () {
  let fields = {};
  let fieldsEl = this.selectorEl.querySelectorAll("[data-field-type]");
  this._forEachEl(fieldsEl, function (el) {
    let elementName = el.getAttribute("data-field-name");
    if (fields[elementName] === undefined) {
      fields[elementName] = {
        validation: {}
      };
    }
    fields[elementName].name = elementName;
    fields[elementName].value = this._getVal(el);
    fields[elementName].validation["required"] = fields[elementName].validation["required"] == true ? true : el.hasAttribute("data-field-required");
    fields[elementName].validation["type"] = el.getAttribute("data-field-type");
    fields[elementName].validation["email"] = el.hasAttribute("data-field-email-validate");

    // add error messages to the field data
    if (el.hasAttribute("data-error-messages")) {
      fields[elementName].errorMessages = JSON.parse(el.getAttribute("data-error-messages"));
    }
    if (el.getAttribute("data-field-type") === "radio") {
      let parent = el.parentNode;
      if (parent.nodeName.toLowerCase() === "label") {
        if (parent.hasAttribute("data-error-messages")) {
          fields[elementName].errorMessages = JSON.parse(parent.getAttribute("data-error-messages"));
        }
      }
    }
  }.bind(this));
  return fields;
};
ContactForm.prototype.validateField = function (fieldName) {
  this.removeFieldError(fieldName);
  let fieldData = this.getFieldsValues()[fieldName];

  // .... VALIDATE REQUIRED ...
  // ============================================================================================
  if (fieldData.validation.required === true && (fieldData.value === undefined || fieldData.value === "" || fieldData.value === null)) {
    // -- RADIO OR CHECKBOX --
    if (fieldData.validation.type === "radio" || fieldData.validation.type === "checkbox") {
      let allInputs = this.selectorEl.querySelectorAll("[data-field-name=" + fieldData.name + "]");
      let lastInput = allInputs[allInputs.length - 1];
      if (fieldData.validation.type === "radio") {
        this.printFieldError(lastInput.parentElement, fieldData);
      } else {
        this.printFieldError(lastInput, fieldData);
      }
    }

    // -- ANY OTHER FIELD --
    else {
      let input = this.selectorEl.querySelector("[data-field-name=" + fieldData.name + "]");
      this.printFieldError(input, fieldData);
    }
    return false;
  }
  // ============================================================================================

  // .... VALIDATE EMAIL ...
  // ============================================================================================
  if (fieldData.validation.email === true && !this.EMAIL_REGEX.test(fieldData.value)) {
    let element = this.selectorEl.querySelector("[data-field-name=" + fieldData.name + "]");
    this.printFieldError(element, fieldData);
    return false;
  }
  return true;
};
ContactForm.prototype.isValid = function () {
  let isValidForm = true;

  /**
   * fieldValues: {
   *  [fieldName: string] : {
   *      name: string,
   *      value: any;
   *      validation: { required: boolean }
   *  }
   * }
   */
  let fieldValues = this.getFieldsValues();
  this._forEachEl(this.selectorEl.querySelectorAll(".error"), function (el) {
    el.classList.remove("error");
  });
  let fieldValuesKyes = Object.keys(fieldValues);
  for (let i = 0, len = fieldValuesKyes.length; i < len; i += 1) {
    let fieldData = fieldValues[fieldValuesKyes[i]];
    if (this.validateField(fieldData.name) === false && isValidForm === true) {
      isValidForm = false;
    }
  }
  return isValidForm;
};
function buildContactForm(element) {
  if (element.getAttribute("data-disable-form-validation") === null) {
    new ContactForm(element);
  }
}
const initContactFormInContext = function (context) {
  let contactForms = context.querySelectorAll("[data-contact-form-wrapper]");
  for (let i = 0; i < contactForms.length; i++) {
    buildContactForm(contactForms[i]);
  }
};
const initContactForms = function () {
  let contactForms = document.querySelectorAll("[data-contact-form-wrapper]");
  for (let i = 0; i < contactForms.length; i++) {
    buildContactForm(contactForms[i]);
  }
};
export { initContactFormInContext, initContactForms };